import { ConfigService } from './config.service';
import { AuthenticationService } from './authentication.service';
import { Injectable, NgZone } from "@angular/core";
import { Router } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class AutoLogoutService {
    constructor(
        private authenticationService: AuthenticationService,
        private router: Router,
        private configService: ConfigService,
        private ngZone: NgZone
    ){
        this.check();
        this.initListener();
        this.initInterval();

        this.authenticationService.IsAuthenticated
            .subscribe(isAuthenticated => {
                this._isAuthenticated = isAuthenticated;
            })
    }

    private _isAuthenticated: boolean = false;

    check(){
        if(this.lastAction + this.configService.GetMinutesUntilAutoLogout() * 60 * 1000 - Date.now() < 0 && this._isAuthenticated){
            this.ngZone.run(() => {
                this.authenticationService.Logout();
            //this.router.navigate(['login']);
            })
        }
    }

    reset(){
        this.lastAction = Date.now();
    }

    initListener(){
        this.ngZone.runOutsideAngular(() => {
            document.body.addEventListener('click', () => {
                this.reset();
            })
        })
    }

    initInterval(){
        this.ngZone.runOutsideAngular(() => {
            setInterval(() => {
                this.check();
            }, this.configService.GetAutoLogoutCheckInterval());
        })
        localStorage.removeItem('prikazanoObavestenje');
    }

    get lastAction(){
        return parseInt(localStorage.getItem(this.configService.GetAutoLogoutStoreKey()));
    }

    set lastAction(value){
        localStorage.setItem(this.configService.GetAutoLogoutStoreKey(), value.toString());
    }
}